/*
* вспомогательный класс для всех форм (на страницах, в попапах итд), сам по себе не используется.
* форма отправляется по атрибуту actionв, результат возвращается php скриптом в ифрейм, откуда вызвается
* window.message родительского окна
*
* echo '<script>parent.top.postMessage(\'{"type":"form",  "name": "' . $checkName . '", "data":' . $data . '}\', "*")
*
*
 * У формы обяз должно быть название оно передается в скрытое поле name="check-name",
 * чтобы можно было потом вернуть его ($checkName) для индетификации текущей формы в  обраотчике window.message
 *
 * auth
 * reg
 * subscribe
 * email
 * recover
 * announce
 *
* класс  регистрирует обработчик window.message, работает с гугл капчей;
*
* */

import {scriptonload} from '../modules/scriptonload';
import {event} from '../modules/event';

class Form {
	/*
	* param.isNeedAuth boolen - нужна или нет авторизация для формы
	* */
	constructor(param) {
		this._createElements(param);
        this._checkAction();
		this._createLabel();
		this._addEvents();
		this._addCallback();
		this._addCaptcha();
	}

	_createElements(param) {
        var self = this;
		this.param = param;

        /* Форма может быть в контейнере (чисто оформительский момент), контейнер здесь нужен для придания вида отправляемой формы */
        this.wrapper = param.wrapper;
        this.form = this.wrapper.nodeName == 'FORM' ? this.wrapper : this.wrapper.querySelector('form');

        this.submitBtn = this.form.querySelector('[type="submit"]');
		this.param.name = this.form.getAttribute('name');
		this.googleRecaptchaEl = this.form.querySelector('[data-js="googleRecaptcha"]');
        this.input;
		this.captcha = false;
        this._messageOnCircuit = function(e){
            self._messageOn.call(self, e);
        }
        this.isSending = false;
	}

    _checkAction(){
        var path = this.form.getAttribute('data-action');
        if(path) this.form.setAttribute('action', path);
    }

	_createLabel(){
		var input = document.createElement('INPUT');
		input.name = "check-name";
		input.value = this.param.name;
		input.type = "hidden";
        this.input = input;
		this.form.appendChild(this.input);
	}

	_addEvents() {
		var self = this;
		event.add(this.form, 'submit', function(e){
            // ЗДесь будут проверки, если будут
            if(self.isSending || (self.param.beforeSubmit && !self.param.beforeSubmit())) {
                e.preventDefault();
            } else {
                self.wrapper.className = self.wrapper.className + ' js-sending';
                self.isSending = true;
            }
		});
	}

	_addCallback(){
		event.add(window, 'message', this._messageOnCircuit);
	}

    _messageOn(e){
        try{var data = JSON.parse(e.data)} catch(e){return false;}
        if(data.type != 'form' || data.name != this.param.name) return false;

        var answer = data.data;
        if(answer.status) this.param.onsuccess(answer);
        else this.param.onerror(answer);

        this.wrapper.className = this.wrapper.className.replace(' js-sending', '');
        this.isSending = false;
    }

	_addCaptcha(){
		if(!this.googleRecaptchaEl) return false;

        //Гугл запускает onload c одной и той же функцией, замыкание не помогает, поэтому так
		if(!window.googleRecaptchaOnload){
			window.googleRecaptchaOnload = function(){
				window.googleRecaptchaIsLoading = true;
			}
			scriptonload(['https://www.google.com/recaptcha/api.js?onload=googleRecaptchaOnload&render=explicit&hl=ru']);
		}

		var self = this,
			checkLoading = function (){
				if(window.googleRecaptchaIsLoading) self._showCaptcha.call(self);
				else{
					setTimeout(function(){
						checkLoading();
					}, 200);
				}
			};

		checkLoading();
	}

	_showCaptcha(){
		this.captcha = grecaptcha.render(this.googleRecaptchaEl, {
			'sitekey' : '6LelIhcTAAAAAJVEzzD7smhyGcJhJUiMlYoH-2f6',
			callback: function(response) {
				//console.log(response);
			}
		});
	}

	resetCaptcha(){
		try{
			grecaptcha.reset(this.captcha);
		} catch(e){};
	}

    resetForm (){
        this.form.reset();
    }

    del(){
        event.remove(window, 'message', this._messageOnCircuit);
        this.form.removeChild(this.input);
    }
    destroy(){
		this.del();
	}
};

export {Form};



